export default function getPriceWithoutTaxes(price) {
  return Number((price / 1.141).toFixed(2));
}
